import Joi from "joi-browser";

const DeivceRequestSchema = Joi.object().keys({
    name: Joi.string()
        .trim()
        .required()
        .label("Name")
        .error((errors) => {
            function errorsAsString() {
                return "is required";
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
    firmwareVersion: Joi.string().allow(null, "").label("Firmware Version"),
});

const device = Joi.object().keys({
    label: Joi.string().required(),
    value: Joi.string().required(),
});

const FirmwareSchema = Joi.object().keys({
    devices: Joi.array().items(device).required(),
    firmwareVersion: Joi.string()
        .trim()
        .required()
        .allow(null, "")
        .label("Firmware Version"),
});
export default { DeivceRequestSchema, FirmwareSchema };
